module.exports = __webpack_public_path__ + "img/weixinLogo.2cb4ded9.png";